import type { Identifiers } from '@atlaskit/feature-gate-js-client';
import React, { ReactNode, useMemo } from 'react';
import { useAppSelector } from '../stores/redux.store';
import { getFfsId } from '../utilities/feature-flags';
import { FeatureGatesInit } from './FeatureGatesInit';
import { useAnalyticsAnonymousId } from '../utilities/analytics/analytics-web-client';

type FeatureGateProviderProps = {
  children: ReactNode;
};

export const FeatureGateProvider = ({ children }: FeatureGateProviderProps) => {
  const tenantId = useAppSelector(state => state.context?.tenantCloudId);
  const atlassianAccountId = useAppSelector(state => state.context?.userId);
  const ffsId = getFfsId();
  const analyticsAnonymousId = useAnalyticsAnonymousId();

  const identifiers: Identifiers = useMemo(
    () => ({
      tenantId,
      atlassianAccountId,
      randomizationId: ffsId,
      analyticsAnonymousId,
    }),
    [tenantId, atlassianAccountId, ffsId, analyticsAnonymousId]
  );

  return (
    <FeatureGatesInit identifiers={identifiers} initializingComponent={null}>
      {children}
    </FeatureGatesInit>
  );
};
